import { createFileRoute } from "@tanstack/react-router";

import SystemPromptsAdmin from "@/components/SystemPromptsAdmin";

// Generated to match `src/app/admin/system-prompts/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/system-prompts")({
  component: SystemPromptsAdmin,
});
